import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { isMobile, isTablet } from "react-device-detect";

import ContentsWrapper from '../../../../Public/Wrapper/ContentsWrapper';
import Header from '../../../../Public/Header/Header';
import Spinner from '../../../../Common/UI/Spinner/Spinner';
import * as UserApi from '../../../../Common/Apis/UserApi';
import UserRoleListItem from './UserRoleListItem/UserRoleListItem';
import RoleNameEdit from '../Dialog/RoleNameEdit';
import RolePermissionEdit from '../Dialog/RolePermissionEdit';
import { useNotification } from "../../../../../core/contexts/NotificationContext";
import { useAuth } from "../../../../../core/contexts/AuthContext";

// Manage > Roles. Lists the account's roles and lets non-default roles be added / renamed / have
// their permissions edited / deleted (gated on the Setup > Role Details > Edit permission).
const UserRoleList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [rolesListData, setRolesListData] = useState();
  const [roleNameEditItem, setRoleNameEditItem] = useState();
  const [permissionEditItem, setPermissionEditItem] = useState();
  const [pageSize, setpageSize] = useState((isMobile && !isTablet) ? 10 : 100);
  const [pageNo, setpageNo] = useState(1);

  const { showSuccess } = useNotification();
  const { chkRolePermissions } = useAuth();

  const getList = async (_pageNo, _pageSize) => {
    setIsLoading(true);

    try {
      const resData = await UserApi.getUserRoleList(_pageNo, _pageSize);
      setRolesListData(resData);
    } catch (err) {
      console.log('err', err);
    }

    setIsLoading(false);
  };

  const pageSizeChanged = (i) => {
    setpageSize(i);
    setpageNo(1);
  };

  const pageNoChanged = (i) => {
    setpageNo(i);
  };

  const refreshPage = () => {
    getList(pageNo, pageSize);
  };

  const addRole = () => {
    const dummyRole = { RoleId: "", RoleName: "" };
    setRoleNameEditItem(dummyRole);
  };

  const deleteRole = async (item) => {
    if (!window.confirm("Do you want to delete this role?")) {
      return;
    }

    try {
      setIsLoading(true);
      await UserApi.deleteUserRole(item.RoleId);
      showSuccess({ content: "Successfully deleted", timeout: 3000 });
      setIsLoading(false);
      refreshPage();
    } catch (err) {
      console.log('err', err);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (pageNo && pageSize) {
      getList(pageNo, pageSize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNo, pageSize]);

  return (
    <ContentsWrapper header={<Header title="Roles" />}>
      <div className="row no-gutters">
        <div className="col-lg-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <div className="card">
              <div className="card-body">
                <div className="row ">
                  <div className="col-6">
                    <div className="form-group">
                      <Button
                        type="button"
                        className=" ml-3"
                        style={{ fontWeight: '600' }}
                        variant="contained"
                        color="primary"
                        onClick={() => refreshPage()}
                      >
                        Refresh
                      </Button>
                      {chkRolePermissions("Setup", "Role Details", "Edit") &&
                        <Button
                          type="button"
                          className=" ml-3"
                          style={{ fontWeight: '600' }}
                          variant="contained"
                          color="primary"
                          onClick={() => addRole()}
                        >
                          Add
                        </Button>
                      }
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            {rolesListData && <UserRoleListItem
              items={rolesListData}
              pageSizeChanged={pageSizeChanged}
              pageNoChanged={pageNoChanged}
              editRoleName={e => setRoleNameEditItem(e)}
              editPermission={e => setPermissionEditItem(e)}
              deleteRole={e => deleteRole(e)}
            />}
          </div>
        </div>
      </div>

      {isLoading && <Spinner />}
      <RoleNameEdit
        isShow={roleNameEditItem ? true : false}
        item={roleNameEditItem}
        onRefresh={() => refreshPage()}
        onClose={() => setRoleNameEditItem()}
      />

      <RolePermissionEdit
        isShow={permissionEditItem ? true : false}
        item={permissionEditItem}
        onRefresh={() => refreshPage()}
        onClose={() => setPermissionEditItem()}
      />
    </ContentsWrapper>
  );
};

export default UserRoleList;
